export interface UserAccount {
    userId: string,
    stores: StoreRef[],
}

export interface StoreRef {
    storeId: number,
    kardex: number,
    name: string,
    retailGroupId: string,
}

export interface StoreInfo extends StoreRef {
    availableLists: ProductListRef[],
}

export enum ProductCategories {
    BREAD = "categoryBread",
    FRUITS = "categoryFruits",
    OTHER = "categoryOther",
}

export interface ProductListRef {
    id: string,
    name: string,
    category: ProductCategories,
}

export interface ProductList extends ProductListRef {
    products: Product[]
}

export interface Product {
    id: string,
    displayName: string,
    ean: string,
    imageUrl: string,
    plu: string,
    subcategory: ProductCategory
}

export interface ProductCategory {
    id: string,
    categoryName: string
}

export interface EnabledProductRef {
    id: string,
    listId: string
}

export interface ProductUpdate extends EnabledProductRef {
    isEnabled: boolean,
}

export interface ProductRef {
    id: string,
    isEnabled: boolean
}

export interface ProductsUpdateBody {
    listId: string,
    productUpdates: ProductRef[]
}
